import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const BtnTool = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 11px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  transition: background-color, color 0.3s ease-in-out;

  .icon {
    order: 0;
    margin-left: 0px;
  }

  &:hover {
    color: ${colors.RED};

    .icon {
      stroke: ${colors.RED};
      fill: ${colors.RED};
    }
  }
`;

export const BtnToolColumn = styled.div`
  flex: 0 0 170px;
  max-width: 170px;
  margin-bottom: 10px;
  max-width: 50px;

  .icon {
    display: block;
    margin-bottom: 3px;
    width: 16px;
    height: 16px;
    stroke: ${(props) => (props.saved ? colors.RED : colors.GREY_DARK)};
    transition: background-color, color 0.3s ease-in-out;
  }
`;

export const BtnToolBarWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 14px;

  ${BtnToolColumn} {
    padding: 0 6px;
  }
`;

export const BtnToolbarItemRecipe = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 50px;
  height: 34px;
  .icon {
    width: 34px;
    height: 34px;
    stroke: ${(props) => (props.saved ? colors.RED : colors.GREY)};
    stroke-width: 0.8;
    transition: background-color, color 0.3s ease-in-out;
  }
  .icon-saveslide {
    stroke-width: 0.5;
  }
  &:hover {
    color: ${colors.RED};

    .icon {
      stroke: ${colors.RED};
      fill: ${colors.RED};
    }
  }
`;

export const BtnToolbarRecipe = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SocialItemsWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: ${colors.WHITE};
  border-radius: 10px;
  position: relative;
  margin-top: 10px;
  filter: drop-shadow(4px 4px 26px rgba(179, 186, 186, 0.4));
  &:before {
    content: "";
    display: block;
    height: 0;
    width: 0;
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent ${colors.WHITE} transparent;
  }
  > button {
    outline: none;
  }

  > button:last-child {
    border-radius: 0px 0px 10px 10px;
    overflow: hidden;
  }

  > div:first-child {
    border-radius: 10px 10px 0px 0px;
    overflow: hidden;
  }
`;

export const SocialItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px 10px 15px;
  border-bottom: 1px solid ${colors.GREY_LIGHT};
  color: ${(props) => props.color};
  font-size: 16px;
  font-family: ${fonts.latoRegular};
  cursor: pointer;

  &:hover {
    background-color: ${colors.GREY_LIGHT};
  }

  .icon {
    stroke: ${(props) => props.color};
    fill: ${(props) => props.color};
    margin: 0px 15px 0px 0px;
  }
`;

export const Copied = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 20px 10px 15px;
  border-bottom: 1px solid ${colors.GREY_LIGHT};
  color: ${colors.GREY_DARK};
  font-size: 16px;
  font-family: ${fonts.latoRegular};
`;
